import { gql } from "@apollo/client";
import React from "react";
import { useTheme } from "@mui/material/styles";
import { TextInput } from "components/inputs/Inputs";
import makeStyles from "@mui/styles/makeStyles";
import { GraphqlMutation } from "graphqlUtils/GraphqlMutation";
import {
  Dialog,
  DialogTitle,
  Button,
  DialogContent,
  DialogActions,
  Typography,
  useMediaQuery,
} from "@mui/material";

const UPDATE_INVOICE_GROUP = gql`
  mutation UpdateInvoiceGroup($input: UpdateInvoiceGroupInput!) {
    updateInvoiceGroup(input: $input) {
      id
      name
      nurseries {
        id
        name
      }
    }
  }
`;

const useStyles = makeStyles({
  inputStyle: { width: "100%", maxWidth: "350px", marginBottom: "15px" },
  text: { marginBottom: "30px" },
});

export const UpdateInvoiceGroupModal = (props) => {
  const { open, onCancel, onSubmit, invoiceGroup } = props;
  const theme = useTheme();
  const { inputStyle, text } = useStyles();
  const [name, updateName] = React.useState("");
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));

  React.useEffect(() => {
    updateName(invoiceGroup.name);
  }, [invoiceGroup, updateName]);

  return (
    <Dialog scroll="paper" disableEscapeKeyDown fullScreen={fullScreen} fullWidth open={open}>
      <DialogTitle>
        <Typography variant="h4" component="h4">
          Create Invoice Group
        </Typography>
      </DialogTitle>
      <DialogContent>
        <Typography className={text} variant="body1" component="p">
          The name of the invoice group should exactly match the name of the nursery in Xero, i.e.
          the name of the nursery that would appear on the invoice.
        </Typography>
        <TextInput
          required
          variant="outlined"
          className={inputStyle}
          label="Name..."
          value={name}
          onChange={(event) => updateName(event.target.value)}
        />
        <DialogActions>
          <Button onClick={() => onCancel()} color="primary">
            Cancel
          </Button>
          <GraphqlMutation mutation={UPDATE_INVOICE_GROUP} withError>
            {(updateIg, { loading }) => {
              const variables = {
                input: { id: invoiceGroup.id, name },
              };

              const submit = async () => {
                const result = await updateIg({ variables });
                if (result.data) {
                  onSubmit();
                }
                return result;
              };

              return (
                <Button disabled={loading || name === ""} onClick={submit} color="primary">
                  Save
                </Button>
              );
            }}
          </GraphqlMutation>
        </DialogActions>
      </DialogContent>
    </Dialog>
  );
};
